import { render, staticRenderFns } from "./ProgramSupervisors.vue?vue&type=template&id=7780236a&scoped=true"
import script from "./ProgramSupervisors.vue?vue&type=script&lang=js"
export * from "./ProgramSupervisors.vue?vue&type=script&lang=js"
import style0 from "./ProgramSupervisors.vue?vue&type=style&index=0&id=7780236a&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780236a",
  null
  
)

export default component.exports